<template>
  <svg
    viewBox="0 0 127 24"
    :class="[classes.shard]"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <path :d="direction" :fill="fill" data-testid="badge-button-color" />
  </svg>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import {
  BrandContext,
  injectBrand
} from "@fresh8/ad-data-composition/src/brand";
import { defineComponent, computed } from "vue";

const useStyles = createUseStyles({
  shard: {
    height: "100%",
    width: "35px"
  }
});

export default defineComponent({
  name: "Shard",
  components: {},
  props: {
    shardDirection: {
      type: String,
      required: true
    },
    teamColor: {
      type: String,
      required: false,
      default: undefined
    }
  },
  setup(props) {
    const { brand, teamBranding } = injectBrand() || ({} as BrandContext);
    const classes = useStyles();

    const fill = computed(() => {
      if (brand.value?.adTemplate?.team?.useTeamColors) {
        return props.teamColor || teamBranding.value.banner.backgroundColor;
      } else {
        return teamBranding.value.banner.backgroundColor;
      }
    });

    const direction = computed(() => {
      switch (props.shardDirection) {
        case "left top":
          return "M0 0v24h127L116.6 0H0z";
        case "left bottom":
          return "M0 24V0h127l-10.4 24H0z";
        case "right top":
          return "M127 0v24H0L10.4 0H127z";
        case "right bottom":
          return "M127 24V0H0l10.4 24H127z";
        default:
          return "M0 24V0h127l-10.4 24H0z";
      }
    });

    return {
      classes,
      fill,
      direction
    };
  }
});
</script>
